if (document.querySelectorAll('.share-link')) {
	const selectors = document.querySelectorAll('.share-link')
	selectors.forEach(selector => {
		const h = selector.getAttribute('href')
		let u = h.replace('[SITEURL]', encodeURI(`http://${location.hostname}/`))
		u = u.replace('[SITENAME]', encodeURI(document.title))
		selector.setAttribute('href', u)
	})
}